import { render, staticRenderFns } from "./CommissionsModal.vue?vue&type=template&id=fee8dc42&scoped=true"
import script from "./CommissionsModal.vue?vue&type=script&lang=js"
export * from "./CommissionsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee8dc42",
  null
  
)

export default component.exports